/**
 * Customer app entry point.
 *
 * React Native Web renders straight through `react-dom/client`. The Tailwind
 * stylesheet is imported first so the token variables exist before the first
 * React Native Web style is resolved.
 */

import { createRoot } from 'react-dom/client';

import { App } from './App';
import '../global.css';
import './styles.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Missing #root element in index.html');
}

createRoot(container).render(<App />);

// A service worker is what makes the app installable on Android and allows the
// app shell to open without a connection. It is skipped during development so a
// cached shell never masks a change.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // An unavailable service worker costs offline support, not correctness.
    });
  });
}
